import React, { useEffect, useState } from "react";
import TableDemo from "components/TableDemo";
import SupplierQuotationsColumn from "data/SupplierQuotationsColumn";
import { useSearchParams } from "react-router-dom";
import { quotationApi } from "api/quotations";

const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("status") || "";
  const orderId = searchParams.get("orderId") || "";
  const name = searchParams.get("name") || "";

  const fetchData = async () => {
    try {
      const params = new URLSearchParams();
      if (status) params.append("status", status);
      if (orderId) params.append("orderNumber", orderId);
      if (name) params.append("name", name);
      const res = await quotationApi.listSupplierAdmin(
        Object.fromEntries(params.entries())
      );
      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [status, orderId, name]);

  return (
    <section className="mt-3">
      <TableDemo
        data={data?.data}
        columns={SupplierQuotationsColumn(fetchData)}
        title="طلبات تسعير الموردين"
        totalCount={data?.pagination?.totalDocs}
        loading={loading}
        extraComponent={
          <div className="flex gap-2">
            {[
              { key: "", label: "الكل" },
              { key: "pending", label: "بانتظار اختيار" },
              { key: "chosen", label: "تم الاختيار" },
              { key: "invoiced", label: "بفاتورة" },
            ].map((opt) => (
              <button
                key={opt.key || "all"}
                onClick={() => {
                  if (opt.key) searchParams.set("status", opt.key);
                  else searchParams.delete("status");
                  setSearchParams(searchParams);
                }}
                className={`rounded-full px-3 py-1 text-xs ${
                  status === opt.key
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-gray-700"
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        }
      />
    </section>
  );
};

export default Index;
